import { BillingPage } from "@src/pages/Billing";
import { navigation } from "@src/navigation";
import { useActor } from "@src/providers/actorProvider";
import { Navigate } from "react-router-dom";

export function meta() {
  return [
    { title: "Billing" },
    { name: "description", content: "Billing page" },
  ];
}

export default function Billing() {
  const actor = useActor();

  if (actor.type !== "physician") {
    return <Navigate to={navigation.patients()} replace />;
  }

  return <BillingPage />;
}
